import { PhotoType } from "@instacover/instacar-database/browser"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { useSessionDetail, useStepWithMedia } from "@/services/dexie"

import { BackButton } from "../../../../components/buttons/BackButton"
import { ClientRedirect } from "../../../../components/ClientRedirect"
import { useGetStepTexts } from "../../../../locales/photoType"
import { LINKS } from "../../../../routing/links"
import { useStepsRouting } from "../../../../routing/useStepsRouting"
import { VideoStep } from "../../../../sections/videos/VideoStep"
import { useBacklink } from "../../../../utils/session"

const pathParamsSchema = z.object({ step: z.enum(PhotoType) })

export const Route = createFileRoute("/$sessionId/_session/video/$step")({
  params: {
    parse: (rawParams) => pathParamsSchema.parse(rawParams),
  },
  component: VideoStepRoute,
})

function VideoStepRoute() {
  const { step, sessionId } = Route.useParams()
  const backlink = useBacklink()

  const { data: detail } = useSessionDetail(sessionId)
  const { data: currentStep, isLoading: stepLoading } = useStepWithMedia(sessionId, step)

  const { firstUnfinishedStepLink, isLoading: stepsLoading } = useStepsRouting(sessionId)
  const getStepTexts = useGetStepTexts(detail?.vehicleType)

  if (!currentStep) {
    if (stepLoading || stepsLoading) return null
    return <ClientRedirect to={firstUnfinishedStepLink ?? LINKS.finalCheck(sessionId)} />
  }

  const { name: type, canSkip, videos } = currentStep
  const { name, guide } = getStepTexts(type)

  return (
    <div style={{ position: "relative" }}>
      {backlink && <BackButton backlink={backlink} />}

      <VideoStep sessionId={sessionId} type={type} canSkip={canSkip} heading={name} guideText={guide} videos={videos} />
    </div>
  )
}
